import * as React from 'react'
import {styled} from '@mui/material/styles'
import Button from '@mui/material/Button'

// Border/text follow the survey's button colour inside a themed survey;
// fall back to the original defaults via CSS var fallbacks elsewhere.
const CustomOutlineButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 14,
  padding: '8px 15px',
  border: '1px solid',
  lineHeight: 1.5,
  backgroundColor: 'transparent',
  color: 'var(--survey-button-color, #E84F6B)',
  borderColor: 'var(--survey-button-color, #E84F6B)',
  borderRadius: '0',
  '&:hover': {
    // Subtle ~9% tint of the survey's button colour; falls back to the original
    // pink tint outside a themed survey (or where color-mix is unsupported).
    backgroundColor:
      'color-mix(in srgb, var(--survey-button-color, #E84F6B) 9%, transparent)',
    borderColor: 'var(--survey-button-color, #E82347)',
    color: 'var(--survey-button-color, #E82347)',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    borderColor: 'var(--survey-button-color, #E84F6B)',
  },
  '&:focus': {
    //boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
  },
})

export default function WbOutlineButton({CustomOutlineButtonText, ...props}) {
  return (
    <CustomOutlineButton
      variant="outlined"
      disableRipple
      {...props}
    >
      {CustomOutlineButtonText}
    </CustomOutlineButton>
  )
}
